import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";

interface IInstallmentSectorMapping {
    bankCode: string;
    maxInstallmentCount: number;
}

interface IPostUpdateSectorInstallmentMappingRequest {
    sectorId: number;
    list: IInstallmentSectorMapping[];
}

async function postUpdateSectorInstallment(data: IPostUpdateSectorInstallmentMappingRequest): Promise<BaseResponse<any>> {
    try {
        const response = await axiosInstance.post("/Merchant/UpdateInstallmentMappingSector", data);
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function usePostUpdateSectorInstallmentMapping(data: IPostUpdateSectorInstallmentMappingRequest) {
    return useMutation<any | undefined, Error, IPostUpdateSectorInstallmentMappingRequest>(
        (data) => postUpdateSectorInstallment(data)
    );
}
